export default {
    CONTACT_MADE: 1,
    CLAIM_PAYMENT: 2,
    NOT_RECOGNIZE_DEBT: 3,
    RESCHEDULING: 4,
    NON_CONTACT: 5,
    DELOCALISED: 6,
    CONTACT_WITH_OTHER: 7,
    PROPOSE: 8,
    IN_DEAL: 9,
    SEND_WHATSAPP: 10,
    CONTACT_WITH_WHATSAPP: 11,
    BAIXA_MANUAL: 12,
    BAIXA_CREDOR: 13,
    OBS: 15,
    DEAL: 17,
    DEAL_INSTALLMENT: 18,
    NO_CONDITIONS: 19,
    NO_INTERSTING: 20,
    RETURN_CPC: 21,
    PREVENT: 22,
    IN_DEAL_V2: 23,
    DIGITAL_CONTACT: 24,
    MUTE: 25,
    UNKNOWN_CLIENT: 26,
    DECEASED: 27,
    MESSAGE_WITH_OTHER: 28,
    MATTRESS_DEAL: 29,
};

